






















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ComponentModel } from '@/models';

@Component
export default class BaseProperties extends Vue {
  @Prop()
  model!: ComponentModel;
}
